(function () {
    if (typeof preorder_message == "undefined") {
        preorder_message = null;
    }

    function getCurrentDateTimeInTimezone(timezone = 'Europe/London') {
      const options = {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };
    
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const currentDateTimeString = formatter.format(new Date());
      const dateInTimezone = new Date(currentDateTimeString);
      return dateInTimezone;
    }
    
    const shipping = {
        daysOff: $(".shipping-logic-script").data("days-off").split(","),
        nonWorkingDates: [],
        dispatch: $(".shipping-logic-script").data("dispatch"),
        cutOffTime: null,
        inStockTransportTime1Man: $(".shipping-logic-script").data("instocktransporttime1man"),
        inStockTransportTimeXDP: $(".shipping-logic-script").data("instocktransporttimexdp"),
        inStockTransportTime3PL: $(".shipping-logic-script").data("instocktransporttime3pl"),
        inStockTransportTimeCPL: $(".shipping-logic-script").data("instocktransporttimecpl"),
        inStockTransportTime2Man: $(".shipping-logic-script").data("instocktransporttime2man"),
        deliveryWindowInStock: $(".shipping-logic-script").data("deliverywindowinstock"),
        deliveryWindowInStockBJS: $(".shipping-logic-script").data("deliverywindowinstockbjs"),
        deliveryWindowPreOrder: $(".shipping-logic-script").data("deliverywindowpreorder"),   
        deliveryWindowPreOrder2Man: $(".shipping-logic-script").data("deliverywindowpreorder2man"),
        hasParasolDate: $(".shipping-logic-script").data("hasparasoldate"),
        back: $(".shipping-logic-script").data("back-in-stock"),
        preOrder: false,
        twoManDeliveryTags: ["meta-courier:BJS"],
	      isTwoManDelivery: false,
        now: getCurrentDateTimeInTimezone(),
        today: getCurrentDateTimeInTimezone(),
        getBy: "Get it by",
        init: function () {          
          this.attachEventsToControls();	
          this.today = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
          
          let preorderMessage = this.getPreorderMessage();
          this.preOrder = preorderMessage ? this.parseDate(preorderMessage) : false;
          
          if (this.daysOff !== null && this.daysOff.length > 0) {
            this.daysOff.forEach(function(dayOffValue) {
				shipping.nonWorkingDates.push(shipping.parseDate(dayOffValue));
            });
          }
			
          if (product_tags && this.twoManDeliveryTags.some((i) => product_tags.includes(i)) ) {
            this.isTwoManDelivery = true;
  		  }
    
          this.showInitialEstimatedDeliveryDateRange();
        },

        getPreorderMessage: function() {
            let preorderTag = window?.product_tags?.split(',').find(element => element.startsWith("meta-pre-order:"));
            if (preorderTag) {
                return preorderTag.replace("meta-pre-order:", "").trim();
            }
            return null;
        },

        showInitialEstimatedDeliveryDateRange: function () {
            console.log("Updating estimated delivery date range...");
        
            let earliestAvailableDate = this.getEarliestAvailableDate();
            earliestAvailableDate = this.adjustForCutoffTime(earliestAvailableDate);
            let [minDeliveryDate, maxDeliveryDate] = this.calculateDeliveryDates(earliestAvailableDate);
        
            // Store set delivery dates for parasol comparison
            this.furnitureMaxDeliveryDate = maxDeliveryDate;
        
            this.updateUIWithDeliveryDates(minDeliveryDate, maxDeliveryDate);
            this.updateUIParasolText();
            this.updateUIParasolBaseText();
        },

        updateUIParasolText: function () {
            // let { metaPreOrder, parasolProductTags } = $("option:contains(No Parasol)").data() || {};
            let { metaPreOrder, parasolProductTags } = $("option:contains(No Parasol)").data() || $("a.linkgroup-dropdown__link:contains(No Parasol)").data() || $("a.inline-parasol__item-link[data-no-parasol='true']").data() || {};
            
            if ( parasolProductTags ) {
                metaPreOrder = metaPreOrder ? this.parseDateDMY(metaPreOrder) : false;
                product_tags = parasolProductTags

                this.preOrder = metaPreOrder
                this.isTwoManDelivery = parasolProductTags && this.twoManDeliveryTags.some((i) => parasolProductTags.includes(i));
                let earliestAvailableDate = this.getEarliestAvailableDate();
                earliestAvailableDate = this.adjustForCutoffTime(earliestAvailableDate);

                let [ minDeliveryDate, maxDeliveryDate ] = this.calculateDeliveryDates(earliestAvailableDate);

                const existingContent = $('.parasol__content').html();
                const updatedContent = existingContent ? existingContent.replace(/\[date\]/g, this.formatOrdinalDate(maxDeliveryDate)) : existingContent
                const parasolDateRangeString = this.dateRangeToString(minDeliveryDate, maxDeliveryDate, this.hasParasolDate);

                $('.parasol__content').html(updatedContent);
                
                // Determine if parasol date should be shown based on 14-day rule
                const shouldShowParasolDate = !this.furnitureMaxDeliveryDate || 
                                              this.getDaysDifference(minDeliveryDate, this.furnitureMaxDeliveryDate) >= 14;

                if (shouldShowParasolDate) {
                    $('.no-parasol-date').html(parasolDateRangeString).css('opacity', '1');
                    $('.parasol-delivery-line').css('display', '');
                } else {
                    $('.furniture-delivered-by-line').text('Get it by');
                    $('.parasol-delivery-line').css('display', 'none');
                }
            }
        },

        updateUIParasolBaseText: function () {
            let parasolBaseTags = $('.parasol-base-delivery-line').data('parasol-base-tags');
            console.log("parasolBaseTags:", parasolBaseTags);
            if (parasolBaseTags) {
                const result = this.calculateDateRangeForProduct(parasolBaseTags);
                if (result.success) {
                    $('.furniture-delivered-by-line').text('Furniture Delivered by'); //set text to Furniture Delivered by
                    $('.parasol-base-date').html(result.dateRangeString).css('opacity', '1');
                    $('.parasol-base-delivery-line').css('display', '');
                }
            }
        },

        parseDateDMY(dateString) {
            const [day, month, year] = dateString.split('-');
            return new Date(year, month - 1, day);
        },

        getEarliestAvailableDate: function() {
            if (this.preOrder && this.preOrder.getTime() > this.today.getTime()) {
                return this.preOrder;
            }
            return this.today;
        },
        
        adjustForCutoffTime: function(date) {
            if (date.getTime() !== this.today.getTime()) {
                return date;
            }
        
            let [cutOffHours, cutOffMinutes] = this.dispatch.split(":");
            let nextCutOffDateTime = this.addWorkingDays(this.today, 0);
            nextCutOffDateTime = new Date(nextCutOffDateTime.getFullYear(), nextCutOffDateTime.getMonth(), nextCutOffDateTime.getDate(), parseInt(cutOffHours), parseInt(cutOffMinutes));
        
            if (this.now.getTime() > nextCutOffDateTime.getTime()) {
                return this.addWorkingDays(date, 1);
            }
            return date;
        },
        
        calculateDeliveryDates: function(earliestAvailableDate) {
            let minDeliveryDate = earliestAvailableDate;
            let maxDeliveryDate = minDeliveryDate;
        
            if (!this.preOrder) {
                minDeliveryDate = this.calculateMinDeliveryDateInStock(minDeliveryDate);
                maxDeliveryDate = this.calculateMaxDeliveryDateInStock(minDeliveryDate);
            } else {
                maxDeliveryDate = this.calculateMaxDeliveryDatePreOrder(minDeliveryDate);
            }
        
            return [minDeliveryDate, maxDeliveryDate];
        },
        
        calculateMinDeliveryDateInStock: function(date) {
            if (product_tags && product_tags.includes("meta-courier:XDP")) {
                return this.addWorkingDays(date, this.inStockTransportTimeXDP);
            }
            if (product_tags && product_tags.includes("meta-courier:3PL")) {
                return this.addWorkingDays(date, this.inStockTransportTime3PL);
            }
            if (product_tags && product_tags.includes("meta-courier:BJS1.CPL")) {
                return this.addWorkingDays(date, this.inStockTransportTimeCPL);
            }
            if (this.isTwoManDelivery) {
                return this.addWorkingDays(date, this.inStockTransportTime2Man);
            }
            return this.addWorkingDays(date, this.inStockTransportTime1Man);
        },
        
        calculateMaxDeliveryDateInStock: function(date) {
            if (this.isTwoManDelivery) {
                return this.addWorkingDays(date, this.deliveryWindowInStockBJS);
            }
            return this.addWorkingDays(date, this.deliveryWindowInStock);
        },
        
        calculateMaxDeliveryDatePreOrder: function(date) {
            if (this.isTwoManDelivery) {
                return this.addWorkingDays(date, this.deliveryWindowPreOrder2Man);
            }
            return this.addWorkingDays(date, this.deliveryWindowPreOrder);
        },
        
        updateUIWithDeliveryDates: function(minDeliveryDate, maxDeliveryDate) {
            const isShortMonthName = this.hasParasolDate ? true : window.innerWidth < 749;
            let dateRangeString = this.dateRangeToString(minDeliveryDate, maxDeliveryDate, isShortMonthName);
            $(".top_calc_shipping").html(dateRangeString);
            $(".top_calc_shipping").css('opacity', '1');
            $(".shipping-info").show();
        },
        
        updatePriceDisplay: function() {
            var prices = $(".price-item.price-item--regular");
            var price = prices.eq(0).text();
            var price_ = $.trim(price);
            var arr = [...price_];
            var arr1 = arr.shift();
            var newVal = arr.join();
            var final_price = newVal.replace(/\,/g, '');
            var cleanPrice = final_price / 3;
        },

        getAndRenderShippingMethods(target, clear = true, attempt = 0) {
            const postcode = $(target).siblings(".check-shipping-input").val(),
                  country = (postcode.substring(0, 2).toUpperCase() === 'GY') ? 'Guernsey' : (postcode.substring(0, 2).toUpperCase() === 'JE') ? 'Jersey' : (postcode.substring(0, 2).toUpperCase() === 'IM') ? 'Isle Of Man' : 'United Kingdom';
            $.ajax({
              url: "/cart/shipping_rates.json",
              dataType: 'json',
              type: 'POST',
              data: {
                shipping_address: {
                  zip: postcode,
                  country: country,
                  province: "",
                },
              },
              error: function(jqXHR, textStatus, errorThrown) {
                shipping.finishCheck(target, [], clear);
              },
              success: function (data) {
                    if (data === null) {
                        if (attempt >= 10) {
                            shipping.finishCheck(target, [], clear);
                            return;
                        }
                        setTimeout(function () {
                            shipping.getAndRenderShippingMethods(target, clear, attempt + 1);
                        }, 150);
                    } else {
                      console.log("Shipping Rates: success");
                        shipping.finishCheck(target, data.shipping_rates, clear);
                    }
                },
            });
        },

        isChecking: false,

        finishCheck: function (target, rates, clear) {
            const done = function () {
                shipping.renderShippingMethods(target, rates);
                shipping.isChecking = false;
            };

            if (clear) {
                shipping.restoreCart(done);
            } else {
                done();
            }
        },

        savedCart: null,

        restoreCart: function (done) {
            let oldCart = shipping.savedCart;
            if (!oldCart) {
                try {
                    oldCart = JSON.parse(localStorage.getItem("oldCart")) || [];
                } catch (error) {
                    oldCart = [];
                }
            }

            $.ajax({
                url: "/cart/clear.js",
                type: "POST",
                dataType: "json",
                success: function () {
                    if (oldCart.length === 0) {
                        done();
                        return;
                    }

                    // Shopify puts the last item of a multi-item add on top, so send bottom-up to keep the order
                    const items = oldCart.slice().reverse().map(function (item) {
                        return {
                            id: item.id,
                            quantity: item.quantity,
                            properties: item.properties || {},
                        };
                    });

                    // One request, so a refresh can't leave the cart half restored
                    $.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        dataType: "json",
                        contentType: "application/json",
                        data: JSON.stringify({ items: items }),
                        success: function () {
                            done();
                        },
                        error: function () {
                            $.ajax({
                                url: "/cart/clear.js",
                                type: "POST",
                                dataType: "json",
                                success: function () {
                                    shipping.restoreLineByLine(oldCart, done);
                                },
                                error: function () {
                                    console.warn("Shipping: could not restore the cart");
                                    done();
                                },
                            });
                        },
                    });
                },
                error: function () {
                    console.warn("Shipping: could not restore the cart");
                    done();
                },
            });
        },

        restoreLineByLine: function (oldCart, done) {
            // Each /cart/add.js puts its line on top, so re-add from the bottom up to keep the original order
            Shopify.queue = oldCart.slice().reverse();

            Shopify.moveAlong = function () {
                if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        dataType: "json",
                        data: request,
                        success: function success(res) {
                            Shopify.moveAlong();
                        },
                        error: function error() {
                            if (Shopify.queue.length) {
                                Shopify.moveAlong();
                            } else {
                                console.log("done");
                                done();
                            }
                        },
                    });
                } else {
                    console.log("done");
                    done();
                }
            };
            Shopify.moveAlong();
        },

        renderShippingMethods: function (target, rates) {
          let rates_text = "";
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .shippingMethods").empty();
          rates.forEach(function (rate) {
            const shippingMethodNameParts = rate.name.split('(');
            rates_text += "<p>";
            rates_text += `<div>${shippingMethodNameParts[0]} £${rate.price}</div>`;              

            if (shippingMethodNameParts.length > 1) {
                rates_text += `<div class="shippingRate">${shippingMethodNameParts[1].split(')')[0]}</div>`;
            }            
            rates_text += "</p>";
          });
          
          if(rates_text === "" ){
              rates_text = `<p class="noShippingMethods">We can't ship this item to your location.</p>`;
          }
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .loader").hide();
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .shippingMethods").append(rates_text);
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .shippingMethods").show();
        },
      
        renderDateRange: function (dates) {
          if (dates !== null) {
            let date1 = new Date(dates[0]), date2 = new Date(dates[1]);
      		return this.dateRangeToString(date1, date2);
          } else {
          	return "";
          }          
        },        

        showShippingMethods: function (target) {
          $(target).closest(".shipping-wrapper").find(".shipping-info-check").show();
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .shippingMethods").hide();
          $(target).closest(".shipping-wrapper").find(".shipping-info-check .loader").show();

          shipping.isChecking = true;

          $.ajax({
                url: "/cart.js",
                type: "GET",
                dataType: "json",
                success: function (params) {
                    shipping.savedCart = params.items;
                    try {
                        localStorage.setItem("oldCart", JSON.stringify(params.items));
                    } catch (error) {

                    }
                    $.ajax({
                        url: "/cart/clear.js",
                        type: "POST",
                        dataType: "json",
                        success: function (params) {
                            $.ajax({
                                url: "/cart/add.js",
                                type: "GET",
                                data: {
                                    id: $(".form [name=id]").val(),
                                    quantity: 1,
                                },
                                dataType: "json",
                                success: function (params) {
                                    shipping.getAndRenderShippingMethods(target);
                                },
                                error: function () {
                                    shipping.finishCheck(target, [], true);
                                },
                            });
                        },
                        error: function () {
                            shipping.finishCheck(target, [], false);
                        },
                    });
                },
                error: function () {
                    shipping.finishCheck(target, [], false);
                },
            });
        },

        dateRangeToString: function(date1, date2, shortMonthName = false) {
            const currentYear = new Date().getFullYear();
            const date1Year = date1.getFullYear();
            const date2Year = date2.getFullYear();
            const differentYears = date1Year !== date2Year;
            
          	if (date1.getMonth() === date2.getMonth() && date1.getYear() === date2.getYear()) {
              if (date1 === date2) {
              	return (
                    " " +
                    this.getOrdinalSuffix(date1.getDate()) +
                    " " +
                    this.getMonthName(shortMonthName, date1.getMonth()) +
                    (date1Year > currentYear ? " " + date1Year : "")
                );
              } else {
              	return (
                    " " +
                    this.getOrdinalSuffix(date1.getDate()) +
                    " — " +
                    " " +
                    this.getOrdinalSuffix(date2.getDate()) +
                    " " +
                    this.getMonthName(shortMonthName, date2.getMonth()) +
                    (date2Year > currentYear ? " " + date2Year : "")
                );
              }
            }
            
            // Different months or years
            if (differentYears) {
              // Show year for each date when years differ
              return (
                " " +
                this.getOrdinalSuffix(date1.getDate()) +
                " " +
                this.getMonthName(shortMonthName, date1.getMonth()) +
                (date1Year > currentYear ? " " + date1Year : "") +
                " — " +
                " " +
                this.getOrdinalSuffix(date2.getDate()) +
                " " +
                this.getMonthName(shortMonthName, date2.getMonth()) +
                (date2Year > currentYear ? " " + date2Year : "")
              );
            } else {
              // Same year, different months - show year at end if not current year
              return (
                " " +
                this.getOrdinalSuffix(date1.getDate()) +
                " " +
                this.getMonthName(shortMonthName, date1.getMonth()) +
                " — " +
                " " +
                this.getOrdinalSuffix(date2.getDate()) +
                " " +
                this.getMonthName(shortMonthName, date2.getMonth()) +
                (date1Year > currentYear ? " " + date1Year : "")
              );
            }
	    },
    
        getOrdinalSuffix: function (day) {
            switch (parseInt(day)) {
                case 1:
                case 21:
                case 31:
                    return day + "<sup>st</sup>";
                case 2:
                case 22:
                case 32:
                    return day + "<sup>nd</sup>";
                case 3:
                case 23:
                case 33:
                    return day + "<sup>rd</sup>";

                default:
                    return day + "<sup>th</sup>";
            }
        },

        getMonthName: function (short, month) {
            let months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
            if (short) {
                months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
            }
            return months[month];
        },

        formatOrdinalDate(date) {
            const day = date.getDate();
            const month = date.toLocaleString('default', { month: 'long' });
          
            // Add the appropriate suffix to the day
            let daySuffix;
            if (day === 1 || day === 21 || day === 31) {
              daySuffix = 'st';
            } else if (day === 2 || day === 22) {
              daySuffix = 'nd';
            } else if (day === 3 || day === 23) {
              daySuffix = 'rd';
            } else {
              daySuffix = 'th';
            }
          
            return `${day}${daySuffix} ${month}`;
        },

        addDays: function (theDate, days) {
          var date = new Date(theDate.valueOf());
    	  date.setDate(date.getDate() + days);
          return date;
        },

        getDaysDifference: function (date1, date2) {
          const oneDay = 24 * 60 * 60 * 1000;
          const diffInMs = date1.getTime() - date2.getTime();
          return Math.round(diffInMs / oneDay);
        },
    
        addWorkingDays: function(date, workingDays) {
          if(workingDays == 0) {
            // Adjust the date to next working date
          	return this.addWorkingDays(this.addWorkingDays(date, 1), -1);
          }
          
          var direction = workingDays < 0 ? -1 : 1;
          var newDate = date;          
          while (workingDays != 0) {
            newDate = this.addDays(newDate, direction);

            // Saturday and Sunday is the only non-working day. Sunday date + 1 is Tuesday.
            if (newDate.getDay() !== 0 && newDate.getDay() !== 6 && !this.isInDateArray(this.nonWorkingDates, newDate))
            {
                workingDays -= direction;
            }
          }
          
          return newDate;
        },
      
        parseDate: function(dateText) {
          if (dateText.includes("-")) {
			let date_parsed = dateText.split("-"),
                month = parseInt(date_parsed[1]) - 1,
                day = parseInt(date_parsed[0]),
                year = parseInt(date_parsed[2]);
			return new Date(year, month, day);          
          } else {
			let date_parsed = dateText.split("/"),
                month = parseInt(date_parsed[1]) - 1,
                day = parseInt(date_parsed[0]),
                year = parseInt(date_parsed[2]);
			return new Date(year, month, day);                    
          }
        },
      
        isInDateArray: function(array, value) {		  
          var x = array.find(item => {return item.getTime() == value.getTime();});
          return (x !== undefined);
		},
      
        attachEventsToControls: function () {
          $(".check-shipping-input").on("keyup", function() {
            if (event.keyCode === 13) {
		    	event.preventDefault();
			    $(".check-shipping-button").click();
			}
          });
          $(".check-shipping-button").on("click", function (e) {
            if (shipping.isChecking) return;
            if (shipping.validatePostcode(e.target)) {
            	shipping.showShippingMethods(e.target);
            }
          });
          $(".check-shipping-input").on("keyup change", function () {
          	$(this).removeClass("invalid-input");
          });
        },

        validatePostcode: function (target) {
            let postcode = $(target).siblings(".check-shipping-input").val().trim();
            let regex =
                /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/gm;
            let match_ = postcode.match(regex);
            if (match_ === null) {
                $(target).siblings(".check-shipping-input").addClass("invalid-input");
                return false;
            }
            if (!$(target).siblings(".check-shipping-input").val().includes(" "))
                $(target).siblings(".check-shipping-input").val(
                    $(target).siblings(".check-shipping-input")
                        .val()
                        .replace(/^(.*)(\d)/, "$1 $2")
                );
            return true;
        },

        calculateDateRangeForProduct: function(productTags, shortMonthName = false) {
            try {
                window.product_tags = productTags;

                let preorderMessage = this.getPreorderMessage();
                this.preOrder = preorderMessage ? this.parseDate(preorderMessage) : false;
                

                // Update two-man delivery status
                this.isTwoManDelivery = window.product_tags.length > 0 && 
                    this.twoManDeliveryTags.some(tag => window.product_tags.includes(tag));
                
                // Calculate delivery dates using existing methods
                let earliestAvailableDate = this.getEarliestAvailableDate();
                earliestAvailableDate = this.adjustForCutoffTime(earliestAvailableDate);
                let [minDeliveryDate, maxDeliveryDate] = this.calculateDeliveryDates(earliestAvailableDate);
                // Format the date range
                const dateRangeString = this.dateRangeToString(
                    minDeliveryDate, 
                    maxDeliveryDate, 
                    shortMonthName
                );

                // Return the result
                return {
                    success: true,
                    dateRangeString: dateRangeString,
                    minDeliveryDate: minDeliveryDate,
                    maxDeliveryDate: maxDeliveryDate
                };

            } catch (error) {
                return {
                    success: false,
                    dateRangeString: null
                };
            }
        }
    };
  
    shipping.init();
    window._shipping = shipping
})();

// Get Translations value for pre order and in stock 
window.shopifyTranslations = {
  pre_order: "Pre-order",
  in_stock:  "In Stock",
  parasol_delivered_by: "Parasol Delivered by"
};
